import React, {PureComponent} from 'react'
import Logo from './logo';
import MainAnchorMenu from './main-anchor-menu';
import { withRouter } from "react-router";
import Functions from '../../utils/functions';


class Header extends PureComponent {
    render() {
        let path = Functions.getActualPath(this.props.location.pathname);
        let element = path ? this.props.data[path] : false;
        return (
            <div>
                <header className="header">
                    <div className="header-top">
                        <div className="content flex items-end justify-between">
                            <Logo />
                            <MainAnchorMenu siteProperties={this.props.data["site-properties"]} element={element} />
                        </div>
                    </div>
                </header>
                <header className="header mobile">
                    <div className="header-top">
                        <div className="menu-button">
                            <span className="bar"></span>
                            <span className="bar"></span>
                            <span className="bar"></span>
                        </div>
                        <Logo />
                    </div>
                    <div className="nav">
                        <MainAnchorMenu siteProperties={this.props.data["site-properties"]} element={element} />
                    </div>
                </header>
            </div>
        )
    }
}

export default withRouter(Header);